import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';
import { BudgetService } from '../service/budget.service';
import { ProjectNewService } from './service/project-new.service';
import { ProjectsService } from './service/projects.service';
import { UnlinkProjectComponent } from './unlink-project/unlink-project.component';

@Component({
  selector: 'apc-project-management',
  templateUrl: './project-management.component.html',
  styleUrls: ['./project-management.component.scss'],
  providers: [ProjectsService, BudgetService],
})
export class ProjectManagementComponent implements OnInit {
  @Input() modalRef: any;
  @Input() budgetId: string;
  @Input() projectId: string;
  @Input() budget: any;
  @Input() budgets: any;
  @Input() orderId: any;
  @Input() orderName: string;
  public unlinkText: string;
  public unlinkModalRef: any;
  public showProductsDecision: boolean = false;

  public currentSection: string;
  constructor(
    private router: Router,
    private projectService: ProjectsService,
    private toastService: ToastService,
    private modalService: NgbModal,
    private budgetService: BudgetService,
    private projectNewService: ProjectNewService
  ) {}

  ngOnInit(): void {}

  close(budget: any) {
    this.modalRef.dismiss(budget);
  }


  hideMainModal() {
    document.getElementsByClassName('budget-project-modal')[0].setAttribute('style', 'display: none !important');
  }

  showMainModal() {
    document.getElementsByClassName('budget-project-modal')[0].setAttribute('style', 'display: unset !important');
  }

  redirectTo(route: string) {
    this.close(null);
    this.router.navigateByUrl(route);
  }

  selectSection(section) {
    this.currentSection = section;
  }

  unLinkProject() {
    this.projectService.getProject(this.projectId).then((res: any) => {
      this.hideMainModal();
      // looking at the project we are unlinking, checking if it has only one budget left
      if (res.projectBudgets.length === 1) {
        // text 1
        this.unlinkText =
          "<!> You're about to unlink the last budget from this project. <br/>Despite this, the project will remain integrated with the system and you will be able to link budgets in the future.";
      } else {
        // text 2
        this.unlinkText =
          'Are you sure you want to unlink <strong>' +
          this.budget.project.name +
          '</strong> from the budget <strong>' +
          this.budget.name +
          '</strong>?';
      }
      // raising modal to ask the user what he wants
      this.openUnlinkModal();
      this.unlinkModalRef.componentInstance.unlinkText = this.unlinkText;
      this.unlinkModalRef.result.then(
        (res) => {},
        (res) => {
          // if user pressed yes, unlink the project
          if (res.answer) {
            this.projectService.unLinkProject(this.budgetId, { project: { identifier: this.projectId } }).then(
              (unlinkRes) => {
                this.projectNewService._visitedElem$.next(null);
                this.projectNewService._triggerFunnelDetail$.next(false);
                this.toastService.showSuccess('Project Unlinked!');
                // project is unlinked, next step see if the budget has assigned products and ask what to do with them
                this.openUnlinkModal();
                // text 4
                this.unlinkText =
                  'Budget <strong>' + this.budget.name + '</strong> is now unused, do you want to delete it?';
                if (this.budget.budgetProducts.length > 0 && this.budgets.length > 1) {
                  // text 6 + text 4
                  this.unlinkText =
                    'Budget <strong>' +
                    this.budget.name +
                    '</strong> is now unused, do you want to delete it? <br/> <br/> Budget has assigned products (' +
                    this.budget.budgetProducts.length +
                    '), select what you want to do with them.';
                  this.showProductsDecision = true;
                  this.unlinkModalRef.componentInstance.showProductsDecision = this.showProductsDecision;
                  this.unlinkModalRef.componentInstance.budgets = this.budgets.filter(
                    (el) => el.identifier !== this.budget.identifier
                  );
                }
                this.unlinkModalRef.componentInstance.unlinkText = this.unlinkText;
                this.unlinkModalRef.result.then(
                  (res) => {},
                  (res: any) => {
                    if (res.answer) {
                      var budgetToMigrate = res.migrateId;
                      var selectedMigrationBudgetName = res.selectedMigrationBudgetName;

                      this.budgetService.deleteBudgetAndMigrateHours(this.budgetId, res.migrateId).then((res) => {
                        if (budgetToMigrate) {
                          this.toastService.showSuccess(
                            'Budget deleted successfully! Assigned products from ' +
                              this.budget.name +
                              ' got migrated to the budget ' +
                              selectedMigrationBudgetName
                          );
                        } else {
                          this.toastService.showSuccess('Budget deleted successfully!');
                        }
                        this.close({ delete: true, migrate: budgetToMigrate ? true : false, budget: res, budgetId: this.budgetId });
                      });
                    } else {
                      this.close({ delete: false, migrate: true, budget: unlinkRes, budgetId: this.budgetId });
                    }
                  }
                );
              },
              (err) => this.close(err)
            );
          } else {
            this.showMainModal();
          }
        }
      );

      // unutar reposnea od tog modalnog vidit sate
    });
  }

  openUnlinkModal() {
    this.unlinkModalRef = this.modalService.open(UnlinkProjectComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-filler-modal',
    });
    this.unlinkModalRef.componentInstance.modalRef = this.unlinkModalRef;
  }
}
